export default __webpack_public_path__ + "static/media/LOGO_RPP2.37d33709.png";